export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 2-2_06.0cb16d6e.jpg";